module.exports = __webpack_public_path__ + "static/ASCOVIME - Pupil Receive School Items as Gifts 2_2019 1-487605cb9087d383f785e34d286bf90a.jpg";